import React, { useState, useEffect, useContext, useRef } from 'react';
import queryString from 'query-string';
import DayPicker, { DayModifiers } from 'react-day-picker';
import AutoComplete from './CabAutoComplete';
import CabTravellingFor from './CabTravellingFor';
import CabTimeSlotPick from './CabTimeSlotPick';
import CabDuration from './CabDuration';
import DatePickerContainer from '../CabDatePicker/CabDatePickerContainer';
import CabModifySearchCollapsed from './CabModifySearchCollapsed';
import { SetFromPlace } from './../../types';
import { AppContextConsumer, Context } from '../../AppContext';
import { quickBookAPIResponse } from '../../cabsAPIs';

import {
  OUTSTATION_ONE_WAY,
  OUTSTATION_ROUND_TRIP,
  RENTALS,
  CAB_FROM_AIRPORT,
  CAB_TO_AIRPORT,
  getShortCode,
  isOutstationCheck,
  isAirportCheck
} from '../../constants/tripTypes';
import { convertTime12to24 } from '../../utils/timeUtils';
import { getPlaceObject } from '../../utils/reverseGeoCode';
import 'react-day-picker/lib/style.css';
import '../CabDatePicker/CabDayPicker.css';
import '../CabDatePicker/DayPickerCabReset.css';
import './CabModifySearch.css';
import { getAppEnv } from '../../../config/env';
import { CASE_SEARCH_WIDGET } from '../../constants/omniture';
import {
  getCmpFromUrl,
  isInternationalPage,
  isWebView
} from '../../utils/commonUtils';
import { yeildToMainThread } from '../../scheduler';
import CabDatePickerContainer2 from '../CabDatePicker/CabDatePickerContainer2';
import MultiCityMobile from '../MultiCity/MultiCityMobile';
import {
  Stop,
  calculateDaysForMulticity,
  isInvalidMultiStopForDesktop
} from '../MultiCity/util';
import MultiCityDesktop from '../MultiCity/MultiCityDesktop';
import { userActionDone } from '../../utils/displayUtils';
import { TEMPO_TRAVELLER } from '../../constants/miscellaneousConstants';
const dayjs = require('dayjs');
const isMobile = () => window.matchMedia('(max-width: 768px)').matches;
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;
const DATE_FORMAT = 'DD-MM-YYYY';

type CabModifySearchProps = {
  carType?: string;
  openDateWidget?: boolean;
  openTripType?: boolean;
  openTripTypeAndThenDate?: boolean;
  openDestinationWidget?: boolean;
  sourceCityCode?: string;
  destinationCityCode?: string;
  sourceCityName?: string;
  destinationCityName?: string;
  isMobileDevice: boolean;
  title: string;
  topFix?: string;
  returnCloseFlagDefault?: boolean;
  activate?: any;
  setActivate?: any;
  omniString?: string;
  isRydeHomePage?: boolean;
  hrPackages?: any;
  isomorph?: boolean | null | undefined;
  showQuickBookCabsButton?: boolean;
  pickupTime: string;
  defaultTripType: string;
  returnTime: string;
  mcPageStyle?: boolean;
  forwardDate?: number;
  airportCountryCode?: string;
  overlayToggle?: any;
  isOverlayVisible?: boolean;
  intentCaptureType?: string | null;
};

const WIDGET_ID = {
  NONE: null,
  PAGE_LOAD: 0,
  TRIP_TYPE: 1,
  FROM_CITY: 2,
  TO_CITY: 3,
  DATE: 4,
  PICKUP_TIME: 5,
  DROP_TIME: 6,
  DURATION: 7
};
const CabModifySearchTS = ({
  intentCaptureType,
  carType = '',
  overlayToggle = null,
  openDateWidget = false,
  openTripType = false,
  openDestinationWidget = false,
  openTripTypeAndThenDate = false,
  forwardDate,
  mcPageStyle = false,
  airportCountryCode = 'IN',
  defaultTripType,
  pickupTime,
  returnTime,
  sourceCityCode,
  destinationCityCode,
  sourceCityName,
  destinationCityName,
  isMobileDevice,
  returnCloseFlagDefault = false,
  title,
  topFix,
  omniString = '',
  isRydeHomePage = false,
  hrPackages = [],
  isomorph = false,
  showQuickBookCabsButton = false,
  isOverlayVisible = false
}: CabModifySearchProps) => {
  const { trackTemplateEvent, omniUrlArgs } = useContext(Context);
  const today = new Date();
  const nextDay = new Date(today.getTime() + 1 * 1000 * 60 * 60 * 24);
  const dayPlus2 = new Date(today.getTime() + 2 * 1000 * 60 * 60 * 24);
  const dayPlus3 = new Date(today.getTime() + 3 * 1000 * 60 * 60 * 24);
  const dayPlus4 = new Date(today.getTime() + 4 * 1000 * 60 * 60 * 24);
  const forwardDatePickupTime = new Date(
    today.getTime() + Number(forwardDate) * 1000 * 60 * 60 * 24
  );
  const defaultPickupSelectedDate = (() => {
    if (forwardDate) {
      return forwardDatePickupTime;
    }
    return isomorph ? dayPlus3 : nextDay;
  })();
  const [collapsableFlag, collapsableFlagSet] = useState(false);
  const [travelFor, setTravelFor] = useState(defaultTripType);
  const [pickUpTime, setPickUpTime] = useState(pickupTime);
  const [dropTime, setDropTime] = useState(returnTime);
  const [mobileStops, setMobileStops] = useState<Stop[]>([]);
  const [desktopStops, setDesktopStops] = useState<Stop[]>([]);
  const [multiCityMobileToast, setMultiCityMobileToast] = useState(false);
  const showMultiCityForMweb = true;
  const showMultiCityForDweb = true;
  // const [multiCityDesktopToast, setMultiCityDesktopToast] = useState(false);

  const setcollapsableFlag = async val => {
    await yeildToMainThread(() =>
      requestAnimationFrame(() => collapsableFlagSet(val))
    );
  };
  const [widget, setWidget] = useState<null | number>(null);
  const prevWidget = useRef<null | number>(WIDGET_ID.NONE); // Ref to store the previous state

  const defaultDropSelectedDate = (() => {
    if (forwardDate) {
      return new Date(
        today.getTime() + Number(forwardDate + 2) * 1000 * 60 * 60 * 24
      );
    }
    if (carType == TEMPO_TRAVELLER) {
      return new Date(today.getTime() + Number(1) * 1000 * 60 * 60 * 24);
    }
    return isomorph ? dayPlus4 : dayPlus3;
  })();

  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  const [showLoader, setLoaderState] = useState(false);
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  const [fromCity, setFromCity] = useState(
    (() => {
      if (
        travelFor == OUTSTATION_ONE_WAY ||
        travelFor == OUTSTATION_ROUND_TRIP
      ) {
        return sourceCityName ? sourceCityName : '';
      }
    })()
  );
  const [fromStn, setFromStn] = useState('');
  const [fromPlaceId, setFromPlaceId] = useState<string | null>(null);
  const [fromPlaceObject, setFromPlaceObject] = useState<SetFromPlace>({
    address: null,
    latitude: null,
    longitude: null,
    place_id: null,
    is_city: null,
    city: null,
    is_airport: null
  });
  const [toCity, setToCity] = useState(
    destinationCityName ? destinationCityName : ''
  );

  const [toStn, setToStn] = useState('');
  const [toPlaceId, setToPlaceId] = useState<string | null>(null);
  const [toPlaceObject, setToPlaceObject] = useState<SetFromPlace>({
    address: null,
    latitude: null,
    longitude: null,
    place_id: null,
    is_city: null,
    city: null,
    is_airport: null
  });
  const [selectedDay, setSelectedDay] = useState(defaultPickupSelectedDate);
  const [selectedDayReturn, setSelectedDayReturn] = useState<Date | undefined>(
    new Date()
  );
  const [inputName, setInputName] = useState('tripType');
  const [pickUpFieldError, setPickUpFieldError] = useState(false);
  const [dropFieldError, setDropFieldError] = useState(false);
  const [returnCloseFlag, setReturnCloseFlag] = useState(
    returnCloseFlagDefault
  );
  const [initialHour, initialKm] =
    hrPackages.length > 0 ? hrPackages[0].split(', ') : ['', ''];
  const [hour, setHour] = useState(initialHour ? initialHour : '1 hr');
  const [kms, setKms] = useState(initialKm ? initialKm : '10 kms');
  const [selectedFromDate, setSelectedFromDate] = useState(
    defaultPickupSelectedDate
  );
  const [selectedToDate, setSelectedToDate] = useState(
    isOutstationCheck(travelFor) ? defaultDropSelectedDate : dayPlus2
  );
  const [from, setFrom] = useState(
    () =>
      days[defaultPickupSelectedDate.getDay()] +
      ', ' +
      defaultPickupSelectedDate.getDate() +
      ' ' +
      months[defaultPickupSelectedDate.getMonth()] +
      ' ' +
      defaultPickupSelectedDate.getFullYear()
  );
  const [to, setTo] = useState(
    () =>
      days[defaultDropSelectedDate.getDay()] +
      ', ' +
      defaultDropSelectedDate.getDate() +
      ' ' +
      months[defaultDropSelectedDate.getMonth()] +
      ' ' +
      defaultDropSelectedDate.getFullYear()
  );

  const [airport, setAirport] = useState(
    (() => {
      if (travelFor === CAB_FROM_AIRPORT) {
        return sourceCityName;
      } else if (travelFor === CAB_TO_AIRPORT) {
        return destinationCityName;
      } else {
        return null;
      }
    })()
  );
  const [airportObject, setAirportObject] = useState<SetFromPlace>({
    address: null,
    latitude: null,
    longitude: null,
    place_id: null,
    is_city: null,
    city: null,
    is_airport: null,
    country_code: null
  });
  const [airportCode, setAirportCode] = useState(
    (() => {
      if (travelFor === CAB_FROM_AIRPORT) {
        return sourceCityCode;
      } else if (travelFor === CAB_TO_AIRPORT) {
        return destinationCityCode;
      } else {
        return null;
      }
    })()
  );
  const [nonAirport, setNonAirport] = useState('');
  const [nonAirportObject, setNonAirportObject] = useState<SetFromPlace>({
    address: null,
    latitude: null,
    longitude: null,
    place_id: null,
    is_city: null,
    city: null,
    is_airport: null,
    country_code: null
  });

  useEffect(() => {
    setFrom(
      days[selectedFromDate.getDay()] +
        ', ' +
        selectedFromDate.getDate() +
        ' ' +
        months[selectedFromDate.getMonth()] +
        ' ' +
        selectedFromDate.getFullYear()
    );

    setTo(
      days[selectedToDate.getDay()] +
        ', ' +
        selectedToDate.getDate() +
        ' ' +
        months[selectedToDate.getMonth()] +
        ' ' +
        selectedToDate.getFullYear()
    );

    setSelectedDay(selectedFromDate);
  }, [selectedFromDate, selectedToDate]);

  useEffect(() => {
    if (isOutstationCheck(travelFor)) {
      setSelectedFromDate(defaultPickupSelectedDate);
      setSelectedToDate(defaultDropSelectedDate);
      setPickUpTime('10:00 AM');
      setDropTime('12:00 PM');
    } else {
      const pickUpLocation =
        travelFor === CAB_FROM_AIRPORT
          ? 'Enter Pickup location'
          : 'Enter Drop location';
      const dropLocation =
        travelFor === CAB_FROM_AIRPORT
          ? 'Enter Drop location'
          : 'Enter Pickup location';
      setAirport(
        airport === ''
          ? pickUpLocation
          : airport?.includes('location')
          ? pickUpLocation
          : airport
      );
      setNonAirport(
        nonAirport === ''
          ? dropLocation
          : nonAirport?.includes('location')
          ? dropLocation
          : nonAirport
      );
      setPickUpTime('03:00 PM');
      setDropTime('05:00 PM');
      setSelectedFromDate(defaultPickupSelectedDate);
      setSelectedToDate(defaultDropSelectedDate);
    }
  }, [travelFor]);

  useEffect(() => {
    // to do : whether to keep this
    if (multiCityMobileToast) {
      const hasIncompleteLocations = mobileStops?.some(stop => !stop?.placeId);
      if (!hasIncompleteLocations) {
        setMultiCityMobileToast(false);
      }
    }
  }, [multiCityMobileToast, mobileStops]);

  useEffect(() => {
    if (isMobileDevice) {
      // whenever overlay changes and overlay is not visible, and widget is not null we need to close popup/ widget
      if (!isOverlayVisible && widget != null) {
        closePopup();
      }
    }
  }, [isOverlayVisible]);

  // useEffect(() => {
  //   if (multiCityDesktopToast) {
  //     setTimeout(() => {
  //       setMultiCityDesktopToast(false);
  //     }, 2000);
  //   }
  // }, [multiCityDesktopToast]);

  const closePopup = async () => {
    prevWidget.current = 1000;
    await yeildToMainThread(() => {
      setWidget(null);
      const body = document.getElementsByTagName('body');
      body[0].classList.remove('bodyFixed');
    });
  };

  const onFromChange = async (city: string, stn: string, placeId: string) => {
    trackTemplateEvent(`Cab_SEO${omniString}_From_${city}_Select`);
    let placeObject = await getPlaceObject(placeId, travelFor);
    if (city && stn) {
      placeObject = { ...placeObject, address: `${city}, ${stn}` };
    }
    if (isAirportCheck(travelFor)) {
      if (travelFor === CAB_FROM_AIRPORT) {
        setAirport(city);
        setAirportObject(placeObject);
      } else {
        setNonAirport(`${city}, ${stn}`);
        // console.log('placeObject->', placeObject);
        setNonAirportObject(placeObject);
      }
    }
    // Disallow  OS from city update when page is international and trip type is AT, we do not want to set internation location for OS searches
    if (!(isInternationalPage() && isAirportCheck(travelFor))) {
      setFromCity(city);
      setFromStn(stn);
      setFromPlaceId(placeId);
      setFromPlaceObject(placeObject);
    }
    closePopup();
  };

  const onToChange = async (city: string, stn: string, placeId: string) => {
    trackTemplateEvent(`Cab_SEO${omniString}_To_${city}_Select`);
    let placeObject = await getPlaceObject(placeId, travelFor);
    if (city && stn) {
      placeObject = { ...placeObject, address: `${city}, ${stn}` };
    }
    if (isAirportCheck(travelFor)) {
      if (travelFor === CAB_TO_AIRPORT) {
        setAirport(city);
        setAirportObject(placeObject);
      } else {
        setNonAirport(`${city}, ${stn}`);
        setNonAirportObject(placeObject);
      }
    }
    // Disallow  OS to city update when page is international and trip type is AT.  we do not want to set internation location for OS searches
    if (!(isInternationalPage() && isAirportCheck(travelFor))) {
      setToCity(city);
      setToStn(stn);
      setToPlaceId(placeId);
      setToPlaceObject(placeObject);
    }
    if (
      openTripTypeAndThenDate &&
      (prevWidget.current == WIDGET_ID.TRIP_TYPE ||
        prevWidget.current == WIDGET_ID.PAGE_LOAD)
    ) {
      prevWidget.current = WIDGET_ID.TO_CITY;
      trackTemplateEvent(
        'CAB_SEO_Auto_Open_v2_To_City_Select' + '_' + intentCaptureType
      );
      if (travelFor === OUTSTATION_ROUND_TRIP) {
        setWidget(8);
      } else {
        setWidget(2);
      }
    } else {
      closePopup();
    }
  };

  const saveDates = fetchedDate => {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ];
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const fromStr = `${
      days[fetchedDate.from.getDay()]
    }, ${fetchedDate.from.getDate()} ${
      months[fetchedDate.from.getMonth()]
    } ${fetchedDate.from.getFullYear()}`;
    const toStr = `${
      days[fetchedDate.to.getDay()]
    }, ${fetchedDate.to.getDate()} ${
      months[fetchedDate.to.getMonth()]
    } ${fetchedDate.to.getFullYear()}`;
    setFrom(fromStr);
    setTo(toStr);
    setSelectedFromDate(fetchedDate.from);
    setSelectedToDate(fetchedDate.to);
  };

  const travelForMethod = async (val: string) => {
    yeildToMainThread(() => setTravelFor(val));
    trackTemplateEvent(
      `Cab_SEO${omniString}_Trip_Type_${getShortCode(val)}_Select`
    );
    // if (openTripType && prevWidget.current == 0) {
    //   trackTemplateEvent(
    //     `Cab_SEO${omniString}_Trip_Type_${getShortCode(
    //       val
    //     )}_Select_Trip_Type_Auto_Open`
    //   );
    // }
    if (openTripTypeAndThenDate && prevWidget.current == WIDGET_ID.PAGE_LOAD) {
      trackTemplateEvent(
        `Cab_SEO_Auto_Open_v2${omniString}_Trip_Type_${getShortCode(
          val
        )}_Trip_Type_Select` +
          '_' +
          intentCaptureType
      );
    }
    yeildToMainThread(() => {
      // console.log('To->', toCity, toStn, toPlaceId, destinationCityCode);
      // console.log('From->', fromCity, fromStn, fromPlaceId, sourceCityCode);
      // console.log('val->', val);
      // console.log('airport->', airport, airportObject, airportCode);
      // console.log('nonAirport->', nonAirport, nonAirportObject);
      if (val === OUTSTATION_ONE_WAY) {
        setReturnCloseFlag(false);
      } else {
        setReturnCloseFlag(true);
      }
    });

    if (openTripTypeAndThenDate && prevWidget.current == WIDGET_ID.PAGE_LOAD) {
      yeildToMainThread(() => {
        if (val == CAB_FROM_AIRPORT || val == CAB_TO_AIRPORT) {
          closePopup();
          return;
        } else if (val === OUTSTATION_ROUND_TRIP) {
          if (!toCity) {
            trackTemplateEvent(
              'CAB_SEO_Auto_Open_v2_To_Auto_Suggest_Shown' +
                '_' +
                intentCaptureType
            );
            setWidget(1);
          } else {
            trackTemplateEvent(
              'CAB_SEO_Auto_Open_v2_Date_Widget_Shown' + '_' + intentCaptureType
            );
            setWidget(8);
          }
        } else {
          if (!toCity && val !== RENTALS) {
            // not rentals && city is not selected
            trackTemplateEvent(
              'CAB_SEO_Auto_Open_v2_To_Auto_Suggest_Shown' +
                '_' +
                intentCaptureType
            );
            setWidget(1);
          } else {
            trackTemplateEvent(
              'CAB_SEO_Auto_Open_v2_Date_Widget_Shown' + '_' + intentCaptureType
            );
            setWidget(2);
          }
        }
      });
      prevWidget.current = WIDGET_ID.TRIP_TYPE;
      return;
    } else {
      closePopup();
    }
  };

  const handleDropTimeSlot = (time: string, mer: string) => {
    yeildToMainThread(() => {
      setDropTime(`${time} ${mer}`);
      trackTemplateEvent(`Cab_SEO${omniString}_Drop_Time_Select`);
    });

    if (
      openTripTypeAndThenDate &&
      prevWidget.current == WIDGET_ID.PICKUP_TIME &&
      travelFor == OUTSTATION_ROUND_TRIP
    ) {
      trackTemplateEvent(
        `Cab_SEO_Auto_Open_v2_Drop_Time_Select` + '_' + intentCaptureType
      );
      prevWidget.current = WIDGET_ID.DROP_TIME;
      yeildToMainThread(() => {
        setAllowSearch(2);
      });
    }
    closePopup();
  };

  const handlePickTimeSlot = async (time: string, mer: string) => {
    yeildToMainThread(() => {
      setPickUpTime(`${time} ${mer}`);
      setInputName('tripType');
    });

    trackTemplateEvent(`Cab_SEO${omniString}_Pickup_Time_Select`);

    if (openTripTypeAndThenDate) {
      trackTemplateEvent(
        `Cab_SEO_Auto_Open_v2_Pickup_Time_Select` + '_' + intentCaptureType
      );

      if (
        prevWidget.current == WIDGET_ID.DATE &&
        travelFor == OUTSTATION_ONE_WAY
      ) {
        prevWidget.current = WIDGET_ID.PICKUP_TIME;
        trackTemplateEvent(
          `Cab_SEO_Auto_Open_v2_Auto_Search` + '_' + intentCaptureType
        );
        yeildToMainThread(() => {
          setAllowSearch(2);
        });
        closePopup();
        return;
      } else if (
        prevWidget.current == WIDGET_ID.DATE &&
        travelFor == OUTSTATION_ROUND_TRIP
      ) {
        prevWidget.current = WIDGET_ID.PICKUP_TIME;
        trackTemplateEvent(
          `Cab_SEO_Auto_Open_v2_Drop_Time_Shown` + '_' + intentCaptureType
        );
        yeildToMainThread(() => {
          setWidget(6);
        });
        return;
      } else if (prevWidget.current == WIDGET_ID.DATE && travelFor == RENTALS) {
        prevWidget.current = WIDGET_ID.PICKUP_TIME;
        trackTemplateEvent(
          `Cab_SEO_Auto_Open_v2_Auto_Search` + '_' + intentCaptureType
        );
        yeildToMainThread(() => {
          setWidget(7);
        });
        return;
      }
    }
    closePopup();
  };

  const handlePopup = (idx, cName, e, omniString) => {
    yeildToMainThread(() => {
      requestAnimationFrame(() => {
        if (cName) {
          setWidget(idx);
          setInputName(cName);
        } else {
          setWidget(idx);
        }
        if (isMobileDevice) {
          const body = document.getElementsByTagName('body');
          body[0].classList.add('bodyFixed');
        }
      });
    });
    trackTemplateEvent(omniString);
  };

  const returnFlagPop = event => {
    setReturnCloseFlag(true);
    setTravelFor(OUTSTATION_ROUND_TRIP);
    setWidget(8);
    setInputName('return');
  };

  const escFunction = event => {
    if (event.keyCode === 27) {
      setWidget(null);
    }
  };

  const autoOpenDateSelectTracking = () => {
    if (
      openTripTypeAndThenDate &&
      (prevWidget.current == WIDGET_ID.TRIP_TYPE ||
        prevWidget.current == WIDGET_ID.TO_CITY)
    ) {
      //openTripTypeAndThenDate and  prevWidget.current==0 (previous state was trip type)
      trackTemplateEvent(
        `Cab_SEO${omniString}_Auto_Open_v2_Pickup_Date_Select` +
          '_' +
          intentCaptureType
      );
      if (travelFor == OUTSTATION_ONE_WAY) {
        //openTripTypeAndThenDate and  prevWidget.current==0 (previous state was trip type)
        // trackTemplateEvent(`Cab_SEO_Auto_Search_Widget_v2`);
        prevWidget.current = WIDGET_ID.DATE;
        yeildToMainThread(() => {
          trackTemplateEvent(
            `Cab_SEO${omniString}_Auto_Open_v2_Pickup_time_Shown` +
              '_' +
              intentCaptureType
          );
          setWidget(5);
        });
        return;
        // setPrevWidgetState(2);
      } else if (travelFor == OUTSTATION_ROUND_TRIP) {
        prevWidget.current = WIDGET_ID.DATE;
        return;
      } else {
        prevWidget.current = WIDGET_ID.DATE;
        yeildToMainThread(() => {
          trackTemplateEvent(
            `Cab_SEO${omniString}_Auto_Open_v2_Pickup_time_Shown` +
              '_' +
              intentCaptureType
          );
          setWidget(5);
        });
        return;
      }
    } else if (travelFor == OUTSTATION_ROUND_TRIP) {
      return;
    } else {
      closePopup();
    }
  };

  const autoOpenDropSelectTracking = () => {
    if (openTripTypeAndThenDate && prevWidget.current == WIDGET_ID.DATE) {
      //openTripTypeAndThenDate and  prevWidget.current==0 (previous state was trip type)
      trackTemplateEvent(
        `Cab_SEO${omniString}__Auto_Open_v2_Drop_Date_Select` +
          '_' +
          intentCaptureType
      );

      if (travelFor == OUTSTATION_ROUND_TRIP) {
        prevWidget.current = WIDGET_ID.DATE;
        yeildToMainThread(() => {
          trackTemplateEvent(
            `Cab_SEO${omniString}_Auto_Open_v2_Pickup_time_Shown` +
              '_' +
              intentCaptureType
          );
          setWidget(5);
        });
        return;
      }
    } else {
      closePopup();
    }
  };
  const [allowSearch, setAllowSearch] = useState<null | number>(null);

  useEffect(() => {
    if (allowSearch == 2) {
      prevWidget.current = 1000;
      transferToFunnel(omniUrlArgs);
    }
  }, [allowSearch]);

  const handleDayClickDepart = (
    day: Date,
    selected: DayModifiers,
    e: React.MouseEvent<HTMLDivElement>
  ) => {
    yeildToMainThread(() => {
      const tomorrow = dayjs(day).add(1, 'day');
      setSelectedDay(day);
      setSelectedDayReturn(selected ? undefined : tomorrow);
      autoOpenDateSelectTracking();
    });
    trackTemplateEvent(`Cab_SEO${omniString}_Pickup_Date_Select`);
  };
  const handleDayClickReturn = async (
    day: Date,
    selected: DayModifiers,
    e: React.MouseEvent<HTMLDivElement>
  ) => {
    await yeildToMainThread(() => {
      setSelectedDayReturn(selected ? undefined : day);
      // console.log('handleDayClickReturn');
      autoOpenDropSelectTracking();
    });
    trackTemplateEvent(`Cab_SEO${omniString}_Drop_Date_Select`);
  };

  const handleDuration = (hour: string, kms: string, evt) => {
    setHour(hour);
    setKms(kms);
    if (
      openTripTypeAndThenDate &&
      prevWidget.current == WIDGET_ID.PICKUP_TIME &&
      travelFor == RENTALS
    ) {
      trackTemplateEvent(
        `Cab_SEO_Auto_Open_v2_hr_packages_clicked` + '_' + intentCaptureType
      );
      setTimeout(() => {
        setAllowSearch(2);
      });
    }
    closePopup();
    // setInputName('tripType');
  };

  const changeFocusState = async stPass => {
    setInputName(stPass);
  };

  const handleFocus = () => {
    closePopup();
  };

  const handleFrom = (val: any) => {
    if (val === CAB_FROM_AIRPORT) {
      if (
        airportObject.latitude &&
        airportObject.longitude &&
        airportObject.place_id
      ) {
        return JSON.stringify(airportObject);
      } else {
        return airportCode;
      }
    } else {
      return JSON.stringify(nonAirportObject);
    }
  };
  const handleTo = (val: any) => {
    if (val === CAB_TO_AIRPORT) {
      if (
        airportObject.latitude &&
        airportObject.longitude &&
        airportObject.place_id
      ) {
        return JSON.stringify(airportObject);
      } else {
        return airportCode;
      }
    } else {
      return JSON.stringify(nonAirportObject);
    }
  };
  const handleFieldError = setError => {
    setError(true);
    setTimeout(() => {
      setError(false);
    }, 1500);
  };

  const getUrlObj = () => {
    if (!sourceCityCode && !fromPlaceId) {
      handleFieldError(setPickUpFieldError);
      return;
    }
    if (
      !destinationCityCode &&
      !toPlaceId &&
      travelFor !== RENTALS &&
      !isAirportCheck(travelFor)
    ) {
      handleFieldError(setDropFieldError);
      return;
    }
    if (travelFor === CAB_FROM_AIRPORT && airport?.includes('location')) {
      handleFieldError(setPickUpFieldError);
      return;
    }
    if (travelFor === CAB_TO_AIRPORT && nonAirport.includes('location')) {
      handleFieldError(setPickUpFieldError);
      return;
    }
    if (travelFor === CAB_FROM_AIRPORT && nonAirport?.includes('location')) {
      handleFieldError(setDropFieldError);
      return;
    }
    if (travelFor === CAB_TO_AIRPORT && airport?.includes('location')) {
      handleFieldError(setDropFieldError);
      return;
    }

    // TO DO: needs to be refactored, Ideally based on trip type Location and Airport API apis needs to be called, true for CabsModifySearch.tsx
    let modifedFromPlaceObject = fromPlaceObject;
    let modifedToPlaceObject = toPlaceObject;

    if (travelFor === CAB_FROM_AIRPORT) {
      modifedFromPlaceObject = { ...airportObject, is_airport: true };
      modifedToPlaceObject = nonAirportObject;
    }

    if (travelFor === CAB_TO_AIRPORT) {
      modifedFromPlaceObject = nonAirportObject;
      modifedToPlaceObject = { ...airportObject, is_airport: true };
    }

    const urlObj = {
      fromCity: isAirportCheck(travelFor)
        ? handleFrom(travelFor)
        : fromPlaceId
        ? JSON.stringify(modifedFromPlaceObject)
        : sourceCityCode,
      toCity: (() => {
        if (travelFor === RENTALS) {
          return null;
          return fromPlaceId
            ? JSON.stringify(modifedFromPlaceObject)
            : sourceCityCode;
        }
        return isAirportCheck(travelFor)
          ? handleTo(travelFor)
          : toPlaceId
          ? JSON.stringify(modifedToPlaceObject)
          : destinationCityCode;
      })(),
      tripType: getShortCode(travelFor),
      departDate: dayjs(selectedDay).format(DATE_FORMAT),
      pickupTime: convertTime12to24(pickUpTime),
      packageKey: `${hour.split(' ')[0]}_${kms.split(' ')[0]}`
    }; // for OUTSTATION_ONE_WAY
    if (
      travelFor === OUTSTATION_ONE_WAY &&
      (isMobileDevice
        ? mobileStops?.length > 0
        : desktopStops?.length > 0 &&
          !isInvalidMultiStopForDesktop(desktopStops))
    ) {
      urlObj['returnDate'] = dayjs(selectedToDate).format(DATE_FORMAT);
      urlObj['dropTime'] = convertTime12to24(dropTime);
    }
    if (travelFor === OUTSTATION_ROUND_TRIP) {
      urlObj['departDate'] = dayjs(selectedFromDate).format(DATE_FORMAT);
      urlObj['returnDate'] = dayjs(selectedToDate).format(DATE_FORMAT);
      urlObj['dropTime'] = convertTime12to24(dropTime);
    } else if (travelFor === CAB_FROM_AIRPORT) {
      urlObj['toAirport'] = false;
      urlObj['fromAirport'] = true;
    } else if (travelFor === CAB_TO_AIRPORT) {
      urlObj['toAirport'] = true;
      urlObj['fromAirport'] = false;
    }

    const webViewUrlObj = {
      tripType: getShortCode(travelFor),
      startDate: dayjs(selectedDay).format(DATE_FORMAT),
      pickupTime: convertTime12to24(pickUpTime),
      packageKey: `${hour.split(' ')[0]}_${kms.split(' ')[0]}`
    }; // for OUTSTATION_ONE_WAY
    if (
      travelFor === OUTSTATION_ONE_WAY &&
      (isMobileDevice
        ? mobileStops?.length > 0
        : desktopStops?.length > 0 &&
          !isInvalidMultiStopForDesktop(desktopStops))
    ) {
      urlObj['returnDate'] = dayjs(selectedToDate).format(DATE_FORMAT);
      urlObj['dropTime'] = convertTime12to24(dropTime);
    }
    if (travelFor === OUTSTATION_ROUND_TRIP) {
      webViewUrlObj['startDate'] = dayjs(selectedFromDate).format(DATE_FORMAT);
      webViewUrlObj['returnDate'] = dayjs(selectedToDate).format(DATE_FORMAT);
      webViewUrlObj['dropTime'] = convertTime12to24(dropTime);
    }

    if (fromPlaceId) {
      webViewUrlObj['fromPlaceId'] = fromPlaceId;
    } else {
      webViewUrlObj['from'] = sourceCityCode;
    }

    if (travelFor === RENTALS) {
      if (fromPlaceId) {
        webViewUrlObj['toPlaceId'] = fromPlaceId;
      } else {
        webViewUrlObj['to'] = sourceCityCode;
      }
    } else {
      if (toPlaceId) {
        webViewUrlObj['toPlaceId'] = toPlaceId;
      } else {
        webViewUrlObj['to'] = destinationCityCode;
      }
    }
    if (
      isAirportCheck(travelFor) &&
      (airportObject?.country_code != 'IN' ||
        nonAirportObject?.country_code != 'IN' ||
        (sourceCityCode == urlObj.fromCity && airportCountryCode != 'IN'))
    ) {
      urlObj['intlFlow'] = true;
    }

    return [urlObj, webViewUrlObj];
  };

  const quickBookClicked = async (omniUrlArgs: string) => {
    setLoaderState(true);
    trackTemplateEvent(`Cab_SEO${omniString}_Quick_Book_Click`);
    const [urlObj, webViewUrlObj]: any = getUrlObj();
    // using only urlObj because quick book is only in mweb SEO
    if (urlObj?.pickupTime?.includes(' ')) {
      urlObj.pickupTime = convertTime12to24(urlObj.pickupTime);
    }
    if (urlObj?.dropTime?.includes(' ')) {
      urlObj.dropTime = convertTime12to24(urlObj.dropTime);
    }
    // TO DO: needs to be refactored, Ideally based on trip type Location and Airport API apis needs to be called, true for CabsModifySearch.tsx
    const modifedFromPlaceObject =
      travelFor === CAB_FROM_AIRPORT
        ? { ...fromPlaceObject, is_airport: true }
        : fromPlaceObject;
    const modifedToPlaceObject =
      travelFor === CAB_TO_AIRPORT
        ? { ...toPlaceObject, is_airport: true }
        : toPlaceObject;

    const req = {
      source_location: fromPlaceId ? modifedFromPlaceObject : null,
      destination_location: toPlaceId ? modifedToPlaceObject : null,
      source_city: sourceCityCode ? sourceCityCode : null,
      destination_city: destinationCityCode ? destinationCityCode : null,
      stopovers: null,
      trip_type: urlObj?.tripType,
      departure_date: urlObj?.departDate,
      return_date: urlObj?.returnDate || null,
      pickup_time: urlObj?.pickupTime,
      drop_time: urlObj?.dropTime || null,
      source: `${omniUrlArgs.split('=')[1]}|quickbook_seo`,
      package_key: `${hour.split(' ')[0]}_${kms.split(' ')[0]}`
    };
    try {
      const resp = await quickBookAPIResponse(req);
      setLoaderState(false);
      if (resp?.review_redirection_link) {
        window.location = Object(resp?.review_redirection_link);
      }
    } catch (e) {
      setLoaderState(false);
      console.log('quick book api failed', e);
    }
  };

  useEffect(() => {
    if (showQuickBookCabsButton && isMobile()) {
      trackTemplateEvent(`Cab_SEO${omniString}_Quick_Book_Shown`);
    }

    // set widget after 2 s
    if (
      openDateWidget ||
      openTripType ||
      openDestinationWidget ||
      openTripTypeAndThenDate
    ) {
      setTimeout(() => {
        let widgetAutoOpenTracking = '';
        let widgetDefaultState: number | null = null;
        if (!userActionDone()) {
          if (openDateWidget) {
            widgetAutoOpenTracking =
              `CAB_SEO_Auto_Open_v0_Date_Widget_Shown` +
              '_' +
              intentCaptureType;
            widgetDefaultState = 2;
          } else if (openTripType) {
            widgetAutoOpenTracking =
              `CAB_SEO_Auto_Open_v1_Trip_Type_Widget_Shown` +
              '_' +
              intentCaptureType;
            widgetDefaultState = 4;
          } else if (openTripTypeAndThenDate) {
            if (toCity) {
              widgetAutoOpenTracking =
                `CAB_SEO_Auto_Open_v2_Trip_Type_Widget_Shown` +
                '_' +
                intentCaptureType;
              widgetDefaultState = 4;
            } else {
              widgetAutoOpenTracking =
                `CAB_SEO_Auto_Open_v2_To_Auto_Suggest_Shown` +
                '_' +
                intentCaptureType;
              widgetDefaultState = 1;
              prevWidget.current = WIDGET_ID.PAGE_LOAD;
            }
          }
          trackTemplateEvent(widgetAutoOpenTracking);
          setWidget(widgetDefaultState);
        }
      }, 2000);
    }
  }, []);

  useEffect(() => {
    const mobileElement = document.querySelector('.domChanger'); // Select the DOM element
    if (mobileElement) {
      if (widget !== null) {
        mobileElement.classList.add('makeSticky2'); // Add the new class
      } else {
        mobileElement.classList.remove('makeSticky2'); // Remove the new class
      }
    }

    // Automatically open the date widget when the trip type widget is closed or selected
    if (openTripTypeAndThenDate) {
      if (widget === 4 && prevWidget.current == null) {
        // trip type opened, maintain prevWidget :0
        prevWidget.current = WIDGET_ID.PAGE_LOAD;
      }
    } else if (openTripType) {
      if (widget === 4) {
        prevWidget.current = WIDGET_ID.PAGE_LOAD;
      }
    }
    if (overlayToggle) {
      if (widget != null) {
        overlayToggle(true);
      } else {
        overlayToggle(false);
      }
    }
  }, [widget]);

  const transferToFunnel = (omniUrlArgs: string) => {
    // return
    const [urlObj, webViewUrlObj]: any = getUrlObj();
    let url = '';
    if (isMobile()) {
      let hasIncompleteLocations = false;
      const stopsPlaceIds = mobileStops?.reduce((acc, stop, index) => {
        if (!stop?.placeId) {
          hasIncompleteLocations = true;
        }
        if (stop?.placeId) {
          acc[index] = stop?.placeId;
        }
        return acc;
      }, {});

      if (hasIncompleteLocations) {
        setMultiCityMobileToast(true);
        return;
      }
      setMultiCityMobileToast(false);
      if (stopsPlaceIds && Object.keys(stopsPlaceIds)?.length > 0) {
        const stopsPlaceIdsStr = JSON.stringify(stopsPlaceIds);
        urlObj['stopsPlaceIds'] = stopsPlaceIdsStr;
        webViewUrlObj['stopsPlaceIds'] = stopsPlaceIdsStr;
      }
    } else {
      // const hasIncompleteLocations = desktopStops?.some((stop) => stop?.address === undefined);
      const stopsWithAddress = desktopStops?.filter(
        stop => stop?.address !== undefined && stop?.address !== null
      );
      const addresses = stopsWithAddress?.map(stop => stop?.address);

      // if (hasIncompleteLocations) {
      //   setMultiCityDesktopToast(true);
      //   return;
      // }
      // setMultiCityDesktopToast(false);
      const stopsAddresses = JSON.stringify(addresses);
      urlObj['stopOvers'] = stopsAddresses;
    }
    if (isMobile()) {
      url = isWebView()
        ? `mmyt://react/?page=cabsListing&deeplink=true&${queryString.stringify(
            webViewUrlObj
          )}`
        : `https://cabs.makemytrip.com/cabsListing?${queryString.stringify(
            urlObj
          )}`;
    } else {
      url = `https://cabs.makemytrip.com/cabsListing?${queryString.stringify(
        urlObj
      )}`;
    }
    // get cmp from URL
    const cmp = getCmpFromUrl();

    url = `${url}&${omniUrlArgs}${CASE_SEARCH_WIDGET}&cmp=${cmp}`;
    trackTemplateEvent(`Cab_SEO${omniString}_Search_Click`);
    window.location = Object(url);
  };
  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);
    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  });

  // Calculate the date 3 months from today
  const threeMonthsFromToday = new Date(
    today.getFullYear(),
    today.getMonth() + 3,
    today.getDate()
  );

  const renderMobileHeader = () => {
    return (
      <CabModifySearchCollapsed
        title={title}
        travelFor={travelFor}
        departDate={
          travelFor === OUTSTATION_ONE_WAY
            ? dayjs(selectedDay).format('MMM D, YYYY')
            : dayjs(selectedFromDate).format('MMM D, YYYY')
        }
        returnDate={dayjs(selectedToDate).format('MMM D, YYYY')}
        isMultiCity={mobileStops?.length > 0}
        setcollapsableFlag={setcollapsableFlag}
      />
    );
  };
  const renderDeskopHeader = () => {
    const today = new Date();
    const disabledDays = { before: today };
    const disabledReturnDays = { before: selectedDay };

    const arr = [
      <React.Fragment>
        <AutoComplete
          autoFocus={true}
          travelFor={travelFor}
          placeholder={'Enter PickUp address'}
          closeCityPopup={closePopup}
          onChange={onFromChange}
          widget={widget}
        />
        <div className="hsBackDrop" onClick={closePopup}></div>
      </React.Fragment>,

      <React.Fragment>
        <AutoComplete
          autoFocus={true}
          widget={widget}
          travelFor={travelFor}
          placeholder={'Enter Drop address'}
          closeCityPopup={closePopup}
          onChange={onToChange}
        />
        <div className="hsBackDrop" onClick={closePopup}></div>
      </React.Fragment>,

      <React.Fragment>
        <div className="dayPickerHotelWrap">
          <div className="doubleDaypickerHeader">
            <div className="disable">
              <span className="widgetSprite icCalendar appendRight10"></span>
              <span className="selectedDateField appendBottom8 latoBold font16 blacktext">
                {selectedDay.getDate()} {months[selectedDay.getMonth()]}{' '}
                {selectedDay.getFullYear() % 2000}
              </span>
            </div>
          </div>
          <div className="noHeight">
            <p className="calHeader">
              <span className="font18 latoBold blackText">
                Select Pick-Up Date
              </span>
              <span className="close" onClick={() => closePopup()}></span>
            </p>
            <DayPicker
              selectedDays={selectedDay}
              onDayClick={handleDayClickDepart}
              fromMonth={new Date()}
              numberOfMonths={today.getDate() > 28 ? 3 : 4}
              month={new Date()}
              disabledDays={{ before: today, after: threeMonthsFromToday }}
            />
          </div>
        </div>
        <div className="hsBackDrop" onClick={closePopup}></div>
      </React.Fragment>,

      <React.Fragment>
        <div className="dayPickerHotelWrap">
          <div className="doubleDaypickerHeader">
            <span className="widgetSprite icCalendar appendRight10"></span>
            <span className="selectedDateField appendBottom8 latoBold font16 blacktext">
              {selectedDay.getDate()} {months[selectedDay.getMonth()]}{' '}
              {selectedDay.getFullYear() % 2000}
            </span>
          </div>
          <CabDatePickerContainer2
            selectedDays={selectedDayReturn}
            onDayClick={handleDayClickReturn}
            fromMonth={selectedDay}
            numberOfMonths={2}
            initialMonth={selectedDay}
            disabledDays={disabledReturnDays}
          />
        </div>
        <div className="hsBackDrop" onClick={closePopup}></div>
      </React.Fragment>,

      <React.Fragment>
        <CabTravellingFor
          travelForVal={travelFor}
          closeTravelForPopup={closePopup}
          travelFor={travelForMethod}
          isRydeHomePage={isRydeHomePage}
        />
        <div className="hsBackDrop" onClick={closePopup}></div>
      </React.Fragment>,

      <React.Fragment>
        <CabTimeSlotPick
          selectedTime={pickUpTime}
          closeTravelForPopup={closePopup}
          handleTimeSlot={handlePickTimeSlot}
        />
        <div className="hsBackDrop" onClick={closePopup}></div>
      </React.Fragment>,

      <React.Fragment>
        <CabTimeSlotPick
          selectedTime={dropTime}
          labelText={'Select End Time'}
          closeTravelForPopup={closePopup}
          handleTimeSlot={handleDropTimeSlot}
        />
        <div className="hsBackDrop" onClick={closePopup}></div>
      </React.Fragment>,

      <React.Fragment>
        <CabDuration
          activeHrPackages={hrPackages}
          handleDuration={handleDuration}
          closeTravelForPopup={closePopup}
          selectedPackage={`${hour}, ${kms}`}
        />
        <div className="hsBackDrop" onClick={closePopup}></div>
      </React.Fragment>,

      <React.Fragment>
        <DatePickerContainer
          fromDateSelect={autoOpenDateSelectTracking}
          toDateSelect={autoOpenDropSelectTracking}
          isMobileDevice={isMobileDevice}
          selectedFromDate={selectedFromDate}
          selectedToDate={inputName === 'return' ? undefined : selectedToDate}
          saveDates={saveDates}
          closeCheckinPopup={closePopup}
          handleFocus={handleFocus}
          changeFocusState={changeFocusState}
          inputName={inputName}
        />
        <div className="hsBackDrop" onClick={closePopup}></div>
      </React.Fragment>
    ];
    const isMcPageStyle = mcPageStyle;
    return (
      <React.Fragment>
        <div
          className={`rsw ${widget !== null ? 'widgetOpen' : ''} ${
            topFix ? 'widgetFix' : ''
          } ${isMcPageStyle ? 'cabModifySearchMC' : ''}`}
          style={{
            minWidth: isMcPageStyle ? 'auto' : 'revert-layer',
            borderRadius: isMcPageStyle ? '10px' : 'revert-layer',
            paddingLeft: isMcPageStyle ? '10px' : 'revert-layer',
            paddingRight: isMcPageStyle ? '10px' : 'revert-layer'
          }}
          id={isMobileDevice ? 'cabModifySearchMobile' : `cabModifySearch`}
        >
          {isMobileDevice && (
            <div className="makeFlex ">
              <div className="logoBanner">
                <img
                  src={`${PUBLIC_URL}/static/public/logo2.png`}
                  height={'20px'}
                  width={'62px'}
                  alt="logo"
                />
              </div>
              <div
                className="makeFlex"
                onClick={() => setcollapsableFlag(true)}
              >
                <div
                  style={{
                    color: '#fdfeff',
                    fontSize: '12px',
                    paddingTop: '2px',
                    paddingRight: '4px'
                  }}
                >
                  Close
                </div>
                <div style={{ color: '#f2f2f2' }} className="paddingL7 font18">
                  &#10005;
                </div>
              </div>
            </div>
          )}
          <div className={`rsw_inner ${isMcPageStyle ? '' : 'scaleRswInner'}`}>
            <div
              id="tripTypeWidget"
              className={`rsw_inputBox ${
                widget !== null ? `inactiveWidget` : ``
              } ${widget === 4 ? `activeWidget` : ``}`}
            >
              <label
                onClick={event =>
                  handlePopup(
                    4,
                    'tripType',
                    event,
                    `Cab_SEO${omniString}_Trip_Type_Click`
                  )
                }
                htmlFor="tripType"
                className="lbl_input makeFlex column latoBold loaderOnClick"
              >
                <span className="appendBottom5 latoBold font12 capText deepskyBlueText">
                  TRIP TYPE
                </span>
                <p className="makeFlex">
                  <input
                    id="tripTypeInput"
                    type="text"
                    className="rsw_inputField truncate font16 whiteText"
                    value={`${travelFor}`}
                    readOnly
                  />
                  <span
                    className={`arrow ${
                      widget === 4 ? `arrow-top-wide` : `arrow-down-wide`
                    }`}
                  ></span>
                </p>
              </label>
              {widget === 4 && arr[widget]}
            </div>
            <div
              className={`rsw_inputBox selectHtlCity ${
                widget !== null ? `inactiveWidget` : ``
              } ${widget === 0 ? `activeWidget` : ``}`}
            >
              <label
                onClick={event =>
                  handlePopup(
                    0,
                    'fromCity',
                    event,
                    `Cab_SEO${omniString}_From_Click`
                  )
                }
                htmlFor="fromCity"
                className="lbl_input makeFlex column latoBold loaderOnClick"
              >
                {
                  <span className="appendBottom5 latoBold font12 capText deepskyBlueText">
                    {travelFor !== CAB_FROM_AIRPORT
                      ? travelFor === RENTALS
                        ? 'Pick Up Location'
                        : 'From'
                      : 'Airport'}
                  </span>
                }
                <input
                  id="fromCityInput"
                  type="text"
                  className="rsw_inputField truncate font16 whiteText"
                  value={
                    travelFor === CAB_FROM_AIRPORT
                      ? airport
                      : travelFor === CAB_TO_AIRPORT
                      ? nonAirport
                      : `${fromCity ? fromCity : 'Enter Pickup location'} ${
                          fromStn ? ',' + fromStn : ''
                        }`
                  }
                  readOnly
                />
                {/* <p className="code">{fromStn}</p> */}
              </label>
              <p
                className="dateErrorMsg whiteText"
                style={{ display: pickUpFieldError ? 'block' : 'none' }}
              >
                Please enter pickup location
              </p>
              {widget === 0 && arr[widget]}
            </div>
            {(travelFor === OUTSTATION_ONE_WAY ||
              travelFor === OUTSTATION_ROUND_TRIP) &&
              !isMobileDevice &&
              showMultiCityForDweb && (
                <MultiCityDesktop
                  travelFor={travelFor}
                  desktopStops={desktopStops}
                  setDesktopStops={setDesktopStops}
                />
              )}
            {travelFor !== RENTALS && (
              <div
                className={`rsw_inputBox selectHtlCity ${
                  widget !== null ? `inactiveWidget` : ``
                } ${widget === 1 ? `activeWidget` : ``}`}
              >
                <label
                  onClick={event =>
                    handlePopup(
                      1,
                      'toCity',
                      event,
                      `Cab_SEO${omniString}_To_Click`
                    )
                  }
                  htmlFor="toCity"
                  className="lbl_input latoBold makeFlex column loaderOnClick"
                >
                  <span className="appendBottom5 latoBold font12 capText deepskyBlueText">
                    {travelFor !== CAB_TO_AIRPORT ? 'To' : 'Airport'}
                  </span>
                  <input
                    id="toCityInput"
                    type="text"
                    className={`rsw_inputField truncate font16 whiteText ${
                      toCity ? '' : 'noValue'
                    }`}
                    value={
                      travelFor === CAB_TO_AIRPORT
                        ? airport
                        : travelFor === CAB_FROM_AIRPORT
                        ? nonAirport
                        : `${toCity ? toCity : 'Enter Drop location'} ${
                            toStn ? ',' + toStn : ''
                          }`
                    }
                    readOnly
                  />
                  {/* <p className="code">{toStn}</p> */}
                </label>
                <p
                  className="dateErrorMsg whiteText"
                  style={{ display: dropFieldError ? 'block' : 'none' }}
                >
                  Please enter drop location
                </p>
                {widget === 1 && arr[widget]}
              </div>
            )}
            {(travelFor === OUTSTATION_ONE_WAY ||
              travelFor === OUTSTATION_ROUND_TRIP) &&
              isMobileDevice &&
              showMultiCityForMweb && (
                <MultiCityMobile
                  widget={widget}
                  travelFor={travelFor}
                  setMobileStops={setMobileStops}
                  mobileStops={mobileStops}
                  fromCity={fromCity}
                  toCity={toCity}
                  dayDifference={calculateDaysForMulticity(
                    selectedDay,
                    selectedToDate
                  )}
                />
              )}
            {travelFor === OUTSTATION_ROUND_TRIP && (
              <div
                className={`rsw_inputBox ${
                  widget !== null ? `inactiveWidget` : ``
                } ${
                  widget === 8 && inputName === 'depart' ? `activeWidget` : ``
                }`}
              >
                <label
                  onClick={event =>
                    handlePopup(
                      8,
                      'depart',
                      event,
                      `Cab_SEO${omniString}_PickUp_Date_Click`
                    )
                  }
                  htmlFor="depart"
                  className="lbl_input latoBold makeFlex column loaderOnClick"
                >
                  <span className="appendBottom5 font12 capText deepskyBlueText">
                    Pick-up Date
                  </span>
                  <input
                    id="depart"
                    type="text"
                    className="rsw_inputField font16 whiteText"
                    value={from}
                    readOnly
                    // ref={ip => (checkInInp = ip)}
                  />
                </label>
                {widget === 8 && arr[widget]}
              </div>
            )}
            {travelFor === OUTSTATION_ROUND_TRIP && (
              <div
                className={`rsw_inputBox ${
                  widget !== null ? `inactiveWidget` : ``
                } ${
                  widget === 8 && inputName === 'return' ? `activeWidget` : ``
                } ${inputName === `return` ? `shiftModal` : ``}`}
              >
                {!(isMobileDevice
                  ? mobileStops?.length > 0
                  : desktopStops?.length > 0) && (
                  <a
                    onClick={e => {
                      e.preventDefault();

                      setReturnCloseFlag(false);
                      setTravelFor(OUTSTATION_ONE_WAY);
                    }}
                    className="code crossIcon"
                  >
                    {' '}
                    X{' '}
                  </a>
                )}
                <label
                  onClick={event =>
                    handlePopup(
                      8,
                      'return',
                      event,
                      `Cab_SEO${omniString}_Drop_Date_Click`
                    )
                  }
                  htmlFor="return"
                  className="lbl_input latoBold makeFlex column loaderOnClick"
                >
                  <span className="appendBottom5 Drop font12 capText deepskyBlueText">
                    Drop Date
                  </span>
                  <input
                    id="return"
                    type="text"
                    className="rsw_inputField font16 whiteText"
                    value={to}
                    readOnly
                  />
                </label>
                {null && widget === 8 && inputName === 'return' && arr[widget]}
                <p className="dateErrorMsg whiteText" id="range_error">
                  You are booking cab for more than 30 days
                </p>
              </div>
            )}
            {travelFor !== OUTSTATION_ROUND_TRIP && (
              <div
                className={`rsw_inputBox dayPickerRailWrap dates ${
                  widget !== null ? `inactiveWidget` : ``
                } ${widget === 2 ? `activeWidget` : ``}`}
              >
                <label
                  onClick={event =>
                    handlePopup(
                      2,
                      'depart',
                      event,
                      `Cab_SEO${omniString}_PickUp_Date_Click`
                    )
                  }
                  htmlFor="travelDateDepart"
                  className="lbl_input latoBold makeFlex column loaderOnClick"
                >
                  <span className="appendBottom5 font12 capText deepskyBlueText">
                    Pick - Up Date
                  </span>
                  <input
                    id="travelDateDepartInput"
                    type="text"
                    className="rsw_inputField truncate font16 whiteText"
                    value={from}
                    readOnly
                  />
                  <p className="font16 appendTop2 sCapText whiteText pickupText">
                    <span className="code latoRegular">
                      {days[selectedDay.getDay()]},&nbsp;
                    </span>
                    <span className="code latoBlack">
                      <span className="">{selectedDay.getDate()}</span>
                      <span className="">
                        {' '}
                        {months[selectedDay.getMonth()]}
                      </span>
                      <span className="latoRegular shortYear">
                        {' '}
                        {selectedDay.getFullYear() % 2000}{' '}
                      </span>
                    </span>
                  </p>
                </label>
                {widget === 2 && arr[widget]}
              </div>
            )}
            {returnCloseFlag &&
              travelFor !== CAB_FROM_AIRPORT &&
              travelFor !== RENTALS &&
              travelFor !== CAB_TO_AIRPORT &&
              travelFor !== OUTSTATION_ROUND_TRIP && (
                <div
                  className={`rsw_inputBox dayPickerRailWrap dates ${
                    returnCloseFlag ? '' : 'autoWidth'
                  } ${widget !== null ? `inactiveWidget` : ``} ${
                    widget === 3 && inputName === 'return' ? `activeWidget` : ``
                  }`}
                >
                  {
                    <a
                      onClick={e => {
                        e.preventDefault();
                        setReturnCloseFlag(false);
                        setTravelFor(OUTSTATION_ONE_WAY);
                      }}
                      className="code crossIcon"
                    >
                      {' '}
                      X{' '}
                    </a>
                  }
                  <label
                    onClick={event =>
                      handlePopup(
                        3,
                        'return',
                        event,
                        `Cab_SEO${omniString}_Drop_Date_Click`
                      )
                    }
                    htmlFor="travelDateReturn1"
                    className="lbl_input latoBold makeFlex column loaderOnClick"
                  >
                    <p className="makeFlex spaceBetween">
                      <span className="appendBottom8 font12 capText deepskyBlueText">
                        Drop Date
                      </span>
                    </p>
                    <input
                      id="travelDateReturn1"
                      type="text"
                      className="rsw_inputField truncate font16 whiteText"
                      value={from}
                      readOnly
                    />
                    {
                      <p className="font16 appendTop2 sCapText whiteText dropText">
                        <span className="code latoRegular">
                          {
                            //days[selectedDayReturn.getDay()]
                          }
                          ,&nbsp;
                        </span>
                        <span className="code paddingTB2">
                          <span className="latoBlack">
                            {
                              //selectedDayReturn.getDate()
                            }
                          </span>
                          <span className="latoBlack">
                            {' '}
                            {
                              //months[selectedDayReturn.getMonth()]
                            }
                          </span>
                          <span className="latoRegular shortYear">
                            {' '}
                            {
                              //selectedDayReturn.getFullYear() %2000
                            }{' '}
                          </span>
                        </span>
                      </p>
                    }
                  </label>
                  {widget === 3 && arr[widget]}
                </div>
              )}
            {!returnCloseFlag &&
              !(travelFor === OUTSTATION_ONE_WAY && isMobileDevice) &&
              !(travelFor === CAB_FROM_AIRPORT) &&
              !(travelFor === RENTALS) &&
              !(travelFor === CAB_TO_AIRPORT) &&
              !(
                desktopStops?.length > 0 &&
                !isInvalidMultiStopForDesktop(desktopStops)
              ) && (
                <div
                  className={`rsw_inputBox dayPickerRailWrap dates ${
                    returnCloseFlag ? '' : 'autoWidth'
                  } ${widget !== null ? `inactiveWidget` : ``} ${
                    widget === 3 && inputName === 'return' ? `activeWidget` : ``
                  }`}
                >
                  <label
                    htmlFor="travelDateReturn"
                    className="lbl_input latoBold makeFlex column loaderOnClick"
                  >
                    <p className="makeFlex spaceBetween">
                      <span className="appendBottom8 font12 capText deepskyBlueText">
                        Drop Date
                      </span>
                    </p>
                    <input
                      id="travelDateReturn"
                      type="text"
                      className="rsw_inputField truncate font16 whiteText"
                      value={from}
                      onFocus={event => returnFlagPop(event)}
                      readOnly
                    />
                    {
                      <p className="font16 truncate latoRegular whiteText noReturnSel">
                        Book return for great savings!
                      </p>
                    }
                  </label>
                  {widget === 3 && arr[widget]}
                </div>
              )}
            {travelFor === OUTSTATION_ONE_WAY &&
              (isMobileDevice
                ? mobileStops?.length > 0
                : desktopStops?.length > 0 &&
                  !isInvalidMultiStopForDesktop(desktopStops)) && (
                <div
                  className={`rsw_inputBox ${
                    widget !== null ? `inactiveWidget` : ``
                  } ${
                    widget === 8 && inputName === 'return' ? `activeWidget` : ``
                  } ${inputName === `return` ? `shiftModal` : ``}`}
                >
                  <label
                    onClick={event =>
                      handlePopup(
                        8,
                        'return',
                        event,
                        `Cab_SEO${omniString}_Drop_Date_Click`
                      )
                    }
                    htmlFor="return"
                    className="lbl_input latoBold makeFlex column loaderOnClick"
                  >
                    <span className="appendBottom5 Drop font12 capText deepskyBlueText">
                      Drop Date
                    </span>
                    <input
                      id="return"
                      type="text"
                      className="rsw_inputField font16 whiteText"
                      value={to}
                      readOnly
                    />
                  </label>
                  {widget === 8 && inputName === 'return' && arr[widget]}
                  <p className="dateErrorMsg whiteText" id="range_error">
                    You are booking cab for more than 30 days
                  </p>
                </div>
              )}
            <div
              className={`rsw_inputBox timeslot ${
                widget !== null ? `inactiveWidget` : ``
              } ${widget === 5 ? `activeWidget` : ``}`}
            >
              <label
                onClick={event =>
                  handlePopup(
                    5,
                    'pickUpTime',
                    event,
                    `Cab_SEO${omniString}_PickUp_Time_Click`
                  )
                }
                htmlFor="pickTime"
                className="lbl_input makeFlex column latoBold loaderOnClick"
              >
                <span className="appendBottom5 latoBold font12 capText deepskyBlueText">
                  Pick-Up Time
                </span>
                <p className="makeFlex">
                  <input
                    id="pickTimeInput"
                    type="text"
                    className="rsw_inputField truncate font16 whiteText"
                    value={`${pickUpTime}`}
                    readOnly
                  />
                </p>
              </label>
              {widget === 5 && arr[widget]}
            </div>
            {travelFor === OUTSTATION_ONE_WAY &&
              (isMobileDevice
                ? mobileStops?.length > 0
                : desktopStops?.length > 0 &&
                  !isInvalidMultiStopForDesktop(desktopStops)) && (
                <div
                  className={`rsw_inputBox timeslot ${
                    widget !== null ? `inactiveWidget` : ``
                  } ${widget === 6 ? `activeWidget` : ``}`}
                >
                  <label
                    onClick={event =>
                      handlePopup(
                        6,
                        'dropTime',
                        event,
                        `Cab_SEO${omniString}_Drop_Time_Click`
                      )
                    }
                    htmlFor="dropTime"
                    className="lbl_input makeFlex column latoBold loaderOnClick"
                  >
                    <span className="appendBottom5 latoBold font12 capText deepskyBlueText">
                      Drop Time
                    </span>
                    <p className="makeFlex">
                      <input
                        id="dropTime"
                        type="text"
                        className="rsw_inputField truncate font16 whiteText"
                        value={`${dropTime}`}
                        readOnly
                      />
                    </p>
                  </label>
                  {widget === 6 && arr[widget]}
                </div>
              )}
            {returnCloseFlag &&
              travelFor !== CAB_FROM_AIRPORT &&
              travelFor !== RENTALS &&
              travelFor !== CAB_TO_AIRPORT && (
                <div
                  className={`rsw_inputBox timeslot ${
                    widget !== null ? `inactiveWidget` : ``
                  } ${widget === 6 ? `activeWidget` : ``}`}
                >
                  <label
                    onClick={event =>
                      handlePopup(
                        6,
                        'dropTime',
                        event,
                        `Cab_SEO${omniString}_Drop_Time_Click`
                      )
                    }
                    htmlFor="dropTime"
                    className="lbl_input makeFlex column latoBold loaderOnClick"
                  >
                    <span className="appendBottom5 latoBold font12 capText deepskyBlueText">
                      Drop Time
                    </span>
                    <p className="makeFlex">
                      <input
                        id="dropTime"
                        type="text"
                        className="rsw_inputField truncate font16 whiteText"
                        value={`${dropTime}`}
                        readOnly
                      />
                    </p>
                  </label>
                  {widget === 6 && arr[widget]}
                </div>
              )}
            {travelFor === RENTALS && (
              <div
                className={`rsw_inputBox duration ${
                  widget !== null ? `inactiveWidget` : ``
                } ${widget === 7 ? `activeWidget` : ``}`}
              >
                <label
                  onClick={event =>
                    handlePopup(
                      7,
                      'duration',
                      event,
                      `Cab_SEO${omniString}_Duration_Click`
                    )
                  }
                  htmlFor="duration"
                  className="lbl_input makeFlex column latoBold loaderOnClick"
                >
                  <span className="appendBottom5 latoBold font12 capText deepskyBlueText">
                    Duration
                  </span>
                  <input
                    id="duration"
                    type="text"
                    className="rsw_inputField truncate font16 whiteText"
                    value={from}
                    readOnly
                  />
                  <p className="makeFlex durationText font16 noneText whiteText">
                    <span>{hour} &nbsp;</span>
                    <span className="latoRegular">{kms}</span>
                  </p>
                </label>
                {widget === 7 && arr[widget]}
              </div>
            )}
            <p
              title="Search for Cabs"
              className="pushRight widgetSearchBtn--wrap"
            >
              <button
                className="bluePrimarybtn widgetSearchBtn loaderOnClickSearch"
                onClick={() => transferToFunnel(omniUrlArgs)}
              >
                {isMobileDevice ? 'SEARCH CABS' : 'SEARCH'}
              </button>
              {isMobileDevice && showQuickBookCabsButton && (
                <div className="fullWidth appendTop10">
                  {!showLoader && (
                    <button
                      className="whiteBtn"
                      onClick={() => {
                        quickBookClicked(omniUrlArgs);
                      }}
                    >
                      <img
                        src={`${PUBLIC_URL}/static/public/quickBook.png`}
                        height={'12px'}
                        width={'14px'}
                        alt="logo"
                        className="paddingR4"
                      />
                      QUICK BOOK CAB
                    </button>
                  )}
                  {showLoader && (
                    <button
                      className="whiteBtn"
                      onClick={() => {
                        quickBookClicked(omniUrlArgs);
                      }}
                    >
                      <div className="quickBookLoader"></div>
                    </button>
                  )}
                </div>
              )}
              {multiCityMobileToast &&
                isMobileDevice &&
                mobileStops?.length > 0 && (
                  <div className="whiteText multiCityError">
                    Please enter all the locations to proceed with the booking.
                  </div>
                )}
              {/* <button
                    onClick={() => {
                      setcollapsableFlag(true);
                    }}
                    className="cancelBtn"
                  >
                    Cancel
                  </button> */}
            </p>
          </div>
          {/* {widget!=null  && 
        <div
         onClick={()=>closePopup()}
         className="searchWidgetModal mobileShow"
         ></div>} */}
        </div>
      </React.Fragment>
    );
  };
  return collapsableFlag && isMobileDevice
    ? renderMobileHeader()
    : renderDeskopHeader();
};

export default CabModifySearchTS;
